export const GET_INDICATOR = "indicator/getIndicator"